// Shared project roster used by the home "Real Results" section and the /projects (Recent Work) page.
// Adding or editing entries here updates both surfaces.

export interface Project {
  category: 'Websites' | 'Commercials' | 'Sports' | 'Brand Content';
  title: string;
  src: string;
  image?: string;
  tags: string[];
  description: string;
}

export const projects: Project[] = [
  {
    category: 'Websites',
    title: 'Creator Terminal',
    src: 'https://creatorterminal.com',
    image: '/assets/creator.png',
    tags: ['Websites', 'Branding'],
    description: 'Creator-focused platform with a custom terminal UI and AI-driven workflows.'
  },
  {
    category: 'Websites',
    title: 'Gaard Media',
    src: 'https://gaardmedia.com',
    image: '/assets/gaard.png',
    tags: ['Websites', 'Marketing'],
    description: 'Media agency site focused on conversion, clarity, and showcasing client work.'
  },
  {
    category: 'Websites',
    title: 'Relight Exterior',
    src: 'https://www.relightexteriorlighting.com/',
    image: '/assets/relight-exterior.png',
    tags: ['Websites', 'Lighting', 'Conversion', 'Integrated'],
    description: 'Permanent outdoor lighting site, engineered for conversion and tightly integrated with the booking dashboard.'
  },
  {
    category: 'Websites',
    title: 'My Show Bro',
    src: 'https://myshowbro.com',
    image: '/assets/msb.png',
    tags: ['Websites', 'Branding'],
    description: 'Booking and storefront site for a touring entertainment brand. Fast, conversion-focused, on-brand.'
  },
  {
    category: 'Websites',
    title: 'Marks Heating KC',
    src: 'https://marksheatingkc.com/',
    image: '/assets/marks-heating-kc.png',
    tags: ['Websites', 'HVAC', 'Local', 'Leads'],
    description: 'HVAC service site with transparent pricing, a fast lead form, and same-day booking.'
  },
  {
    category: 'Websites',
    title: 'Pocono Paint',
    src: 'https://pocono-paint.vercel.app/',
    image: '/assets/pocono-paint.png',
    tags: ['Websites', 'Painting', 'Local', 'Gallery'],
    description: 'Residential painting site with a striking before-and-after gallery and a clean quote flow.'
  },
  {
    category: 'Commercials',
    title: 'Affordable Commercial Plumbing in San Diego County',
    src: 'https://www.youtube.com/embed/2p_edyT1vQw',
    tags: ['Commercials', 'Local'],
    description: 'Local commercial highlighting affordable commercial-grade plumbing service in San Diego County.'
  },
  {
    category: 'Commercials',
    title: 'ASAP Drain Guys & Plumbing',
    src: 'https://www.youtube.com/embed/z0nrYnDMwtE',
    tags: ['Commercials', 'Brand'],
    description: 'Brand identity spot for ASAP Drain Guys & Plumbing.'
  },
  {
    category: 'Commercials',
    title: 'Hydro Jetting Temecula California | ASAP Drain Guys & Plumbing',
    src: 'https://www.youtube.com/embed/Tuge4iJvhCQ',
    tags: ['Commercials', 'Service'],
    description: 'Service spot showcasing hydro jetting capabilities in Temecula, California.'
  },
  {
    category: 'Commercials',
    title: 'Clear DrainSewer Commerecial | ASAP Drain Guys & Plumbing',
    src: 'https://www.youtube.com/embed/J20XF3dcKis',
    tags: ['Commercials', 'Service'],
    description: 'Service spot on drain and sewer line clearing.'
  },
  {
    category: 'Commercials',
    title: 'Commercial Water Heater Replacement | ASAP Drain Guys & Plumbing',
    src: 'https://www.youtube.com/embed/1n-mRgOdyYI',
    tags: ['Commercials', 'Service'],
    description: 'Service spot on commercial water heater replacement.'
  },
  {
    category: 'Commercials',
    title: 'We’re Hiring Plumbers | ASAP Drain Guys & Plumbing',
    src: 'https://www.youtube.com/embed/PZE94bEV4fY',
    tags: ['Commercials', 'Recruiting'],
    description: 'Recruiting commercial promoting open plumber positions at ASAP Drain Guys & Plumbing.'
  },
  {
    category: 'Sports',
    title: 'UHFSA Hype Video 2023 "Legacy"',
    src: 'https://www.youtube.com/embed/D5Yy2XJ8te0?start=39',
    tags: ['Sports', 'Content'],
    description: 'High-energy hype piece for a Friday night season opener. Shot, scored, and cut in-house.'
  },
  {
    category: 'Brand Content',
    title: 'USMC Field Meet',
    src: 'https://www.youtube.com/embed/AXqzuJzv6Bc',
    tags: ['Brand', 'Documentary'],
    description: 'Multi-camera event recap film documenting a United States Marine Corps field meet.'
  },
  {
    category: 'Brand Content',
    title: 'Fair Winds and following Seas Lieutenant Peterson',
    src: 'https://www.youtube.com/embed/E7Ec_ng60ZY',
    tags: ['Brand', 'Tribute'],
    description: 'Naval farewell tribute film honoring Lieutenant Peterson, following the traditional Fair Winds and Following Seas send-off.'
  },
  {
    category: 'Brand Content',
    title: 'Beauty Changes Lives Sydell and Arnold Miller "Art of Haircutting" Scholarship',
    src: 'https://www.youtube.com/embed/pO8MOP5jaJo',
    tags: ['Brand', 'Nonprofit'],
    description: 'Branded scholarship spotlight produced for Beauty Changes Lives, profiling the Sydell and Arnold Miller Art of Haircutting program.'
  },
  {
    category: 'Brand Content',
    title: 'This is Memorial Day',
    src: 'https://www.youtube.com/embed/mzXbfPKNyFA',
    tags: ['Brand', 'Tribute'],
    description: 'Memorial Day tribute film honoring those who served and sacrificed.'
  },
  {
    category: 'Brand Content',
    title: 'Team HQ Reviews Brainstorm Fitness',
    src: 'https://www.youtube.com/embed/30Y7LT8EjyE',
    tags: ['Brand', 'Review'],
    description: 'Brand review feature for Brainstorm Fitness, produced as part of the Team HQ Reviews series.'
  },
  {
    category: 'Brand Content',
    title: 'Guys Night Out',
    src: 'https://www.youtube.com/embed/25JBekhCK7w',
    tags: ['Brand', 'Lifestyle'],
    description: 'Short-form lifestyle film telling a guys-night-out story, cut for social-first distribution.'
  }
];

export const projectCategories: Array<Project['category']> = [
  'Websites',
  'Commercials',
  'Sports',
  'Brand Content'
];
